import React, { useState, useEffect } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Select,
  Collapse,
  InputNumber,
  DatePicker,
} from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "./Helper";

const TransactionExcelTableFilter = (props) => {
  const [form] = Form.useForm();
  const [bankSelect, setBankSelect] = useState({
    data: [],
    loading: true,
  });

  const [projectSelect, setProjectSelect] = useState({
    data: [],
    loading: false,
  });

  const [currencySelect, setCurrencySelect] = useState({
    data: [],
    loading: true,
  });
  const [transactionProcessTypeSelect, setTransactionProcessTypeSelect] =
    useState({
      data: [],
      loading: false,
    });

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  useEffect(() => {
    getCurrencies();
    getTransactionProcessTypes();
    RequestHandler.get(`/Bank/GetErpDropdown`).then((response) => {
      setBankSelect({
        data: response,
        loading: false,
      });
    });
  }, []);

  const onProjectSearch = (value) => {
    if (value.length >= 2) {
      setProjectSelect({ data: [], loading: true });

      RequestHandler.get(
        `/TransactionProjectType?$select=id,projectCode,name&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains("projectCode", value)})  and Name ne 'Diğer'`
      ).then((res) => {
        setProjectSelect({ data: res.value, loading: false });
      });
    } else {
      setProjectSelect({ data: [], loading: false });
    }
  };

  const getCurrencies = () => {
    setCurrencySelect({
      ...currencySelect,
      loading: true,
    });
    RequestHandler.get(`/Currency/GetByBankAccounts?$select=id,code`).then(
      (response) => {
        setCurrencySelect({
          data: response,
          loading: false,
        });
      }
    );
  };

  const getTransactionProcessTypes = () => {
    setTransactionProcessTypeSelect({
      ...transactionProcessTypeSelect,
      loading: true,
    });
    RequestHandler.get(`/Types/GetManualTransactionTypes`).then((response) => {
      setTransactionProcessTypeSelect({
        data: response,
        loading: false,
      });
    });
  };

  const onFinish = (values) => {
    {
      let query = "";
      const conditions = [];

      if (values.bankId) {
        conditions.push(`bankId eq ${values.bankId}`);
      }

      if (values.transactionProjectTypeId) {
        conditions.push(
          `transactionProjectTypeId eq ${values.transactionProjectTypeId}`
        );
      }

      if (values.amountMin) {
        conditions.push(`amount Ge ${values.amountMin}`);
      }

      if (values.amountMax) {
        conditions.push(`amount Le ${values.amountMax}`);
      }

      if (values.transactionDateRange) {
        const [startDate, endDate] = values.transactionDateRange;
        conditions.push(odata.dateRange("transactionDate", startDate, endDate));
      }

      if (values.description) {
        conditions.push(odata.contains("description", values.description));
      }

      if (values.erpTransferStatusId == 4) {
        conditions.push(`erpTransferStatusId eq ${values.erpTransferStatusId}`);
      }

      if (values.erpTransferStatusId == 0) {
        conditions.push(`erpTransferStatusId ne 4`);
      }

      if (values.currencyId) {
        conditions.push(`currencyId eq ${values.currencyId}`);
      }

      if (values.transactionProcessTypeValue) {
        conditions.push(
          `transactionProcessTypeValue eq ${values.transactionProcessTypeValue}`
        );
      }

      if (conditions.length !== 0) {
        query = conditions.join(" and ");
      }

      if (props.onFinishFilter) props.onFinishFilter(query);
    }
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="filter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="bankId" label="Banka :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      loading={bankSelect.loading}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                    >
                      {bankSelect.data.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item
                    name="transactionProjectTypeId"
                    label="Proje Adı :"
                  >
                    <Select
                      allowClear
                      showSearch
                      placeholder="En az 2 harf giriniz.."
                      onSearch={onProjectSearch}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.code
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={projectSelect.loading}
                    >
                      {projectSelect.data.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          code={item.projectCode}
                        >
                          {item.name + " (" + item.projectCode + ")"}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Tutar :" style={{ marginBottom: 0 }}>
                    <Input.Group>
                      <Row gutter={1} style={{ flexDirection: "row" }}>
                        <Col span={12}>
                          <Form.Item name="amountMin">
                            <InputNumber min={0} style={{ width: "100%" }} />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name="amountMax">
                            <InputNumber min={0} style={{ width: "100%" }} />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Input.Group>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="transactionDateRange" label="Tarih :">
                    <DatePicker.RangePicker format="DD.MM.YYYY" />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="currencyId" label="Para Birimi :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={currencySelect.loading}
                    >
                      {currencySelect.data.map(({ id, code }) => (
                        <Select.Option key={id} value={`${id}`}>
                          {code}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="description" label="Açıklama :">
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item
                    name="erpTransferStatusId"
                    label="Excel Aktarma Durumu :"
                  >
                    <Select allowClear showSearch>
                      <Select.Option key={1} value={0}>
                        Aktarılmadı
                      </Select.Option>
                      <Select.Option key={2} value={4}>
                        Excel'e Aktarıldı
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item
                    name="transactionProcessTypeValue"
                    label="Ödeme / Tahsilat Tipi :"
                  >
                    <Select
                      allowClear
                      placeholder="Tümü"
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={transactionProcessTypeSelect.loading}
                    >
                      {transactionProcessTypeSelect.data.map(
                        ({ key, value }) => (
                          <Select.Option key={key} value={key}>
                            {value}
                          </Select.Option>
                        )
                      )}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default TransactionExcelTableFilter;
